import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Layout from 'containers/layout'
import ConnectWallet from 'pages/connect-wallet'
import Whitelist from 'pages/whitelist'
import ArtisPage from 'pages/artis'
import RequireAuth from './require-auth'

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<ConnectWallet />} />
          <Route element={<RequireAuth />}>
            <Route path='/whitelist' element={<Whitelist />} />
            <Route path='/manages-artist' element={<ArtisPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
